import computedValues from './computedValues'
import { getEventData } from './facebookPixelEvents'

export function doConversion(conversionData, userData) {
  switch (conversionData.platform) {
    case 'facebook':
      return fbqTrack(conversionData, userData)

    case 'google':
      return googleTrack(conversionData)

    case 'gtag':
      return gtagTrack(conversionData)
    case 'segment':
      return segmentTrack(conversionData, userData)

    default:
      return
  }
}

function gtagTrack(conversionData) {
  return new Promise((resolve, reject) => {
    if (typeof window.gtag === 'function') {
      const callback = () => resolve()

      window.gtag('event', conversionData.event_name, {
        event_category: conversionData.event_category,
        event_label: conversionData.event_label,
        event_action: conversionData.event_action,
        value: +conversionData.value,
        event_callback: callback,
      })
    } else reject('window.gtag not found!')
  })
}

function googleTrack(conversionData) {
  return new Promise((resolve, reject) => {
    if (typeof window.gtag === 'function') {
      const callback = () => resolve()

      window.gtag('event', 'conversion', {
        send_to: conversionData.google_conversion_id,
        event_callback: callback,
      })
    } else reject('window.gtag not found!')
  })
}

function fbqTrack(conversionData, userData) {
  if (conversionData.facebook_pixel_event && typeof window.fbq === 'function') {
    const eventData = getEventData(conversionData.facebook_pixel_event)
    const data = conversionData.fbq
      ? Object.keys(eventData).reduce((acc, k) => {
          const val = conversionData.fbq[k]
          if (k === 'content_ids' && conversionData.send_page_key_as_content_id)
            acc[k] = [userData.current_page_key]
          /**
           * computedFields will automatically be evaluated and added to the userData
           * object by the flow_controller. So, no need to recomputed them here.
           */ else if (val !== undefined) acc[k] = computedValues(val, userData)
          // else if (val !== undefined) acc[k] = userData[val]
          return acc
        }, {})
      : null
    const trackType = conversionData.use_custom_event ? 'trackCustom' : 'track'
    window.fbq(trackType, conversionData.facebook_pixel_event, data || undefined)
  }
}

function segmentTrack(conversionData, userData) {
  return new Promise((resolve, reject) => {
    if (
      window.analytics &&
      typeof window.analytics.track === 'function' &&
      // Avoids using window.analytics if it's our own June Analytics account, not Segment
      window.analytics.settings?.writeKey !== 'T9NEPNwSPPbPeaCt'
    ) {
      const callback = () => resolve()

      const code = `${conversionData.parameter_payload_code}; customPayload(${JSON.stringify(
        userData
      )})`
      let result = eval(code)
      if (typeof result !== 'object') result = {}

      window.analytics.track(conversionData.event_name, result || {}, {}, callback)
    } else reject('window.analytics not found!')
  })
}
